import React, { useState, useEffect } from "react";

// Kanban Board View
import Board from "react-trello";
import "../Assets/css/style.css";
import {
  Card,
  Stack,
  Container,
  Typography,
  Tooltip,
  IconButton,
  Button,
  TextField,
  Grid,
  Box,
  Tab,
  CircularProgress,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  MenuItem,
  FormControl
} from "@mui/material";
import Modal from "@mui/material/Modal";
import Select from "react-select";
import Page from "../components/Page";
import moment from "moment";
import { notification } from "src/utils/messages";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import TimelineOppositeContent from "@mui/lab/TimelineOppositeContent";
import {
  AutoGraphSharp,
  EditSharp,
  LeaderboardSharp,
  PersonAddAltSharp,
  Close,
  ChangeCircle,
  Check,
  SendSharp,
  ThumbUpAlt
} from "@mui/icons-material";
import {
  getPrimeLeadByLid,
  getPrimeLeadRejectReason,
  getPrimeNewLeadList,
  insertLead,
  insertMemberLeadRejectReason,
  updateprimeleadstatus,
  leadTransferTO,
  updatePrimeLeadMemberForm,
  insertFollowUp,
  checkDuplicateConfirmedLead,
  insertPrimeMember,
  getNewPrimeLeadDataForExport,
  searchMemberList
} from "../api/commonapi";
import DataTable from "react-data-table-component";
import { CSVLink } from "react-csv";
import { fetchallocatelistbyid, fetchleadlistbyid, fetchPrimeleadhistory } from "src/utils/common";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { enGB } from "date-fns/locale";
import { getInvoiceSetting } from "src/api/updateSetting";
import { gender } from "src/constant/variable";
import CustomLoader from "src/components/CustomLoader";

export default function Lead() {
  let loginUser = JSON.parse(localStorage.getItem("userData"));
  const [step, setStep] = useState(0);
  // Tab View
  const [value, setValue] = useState("1");
  const [formdata, setformdata] = useState({
    l_created_by: loginUser.u_id,
    l_type: 0,
    gender: 0
  });
  const [myModal, setMyModal] = useState({
    mval: false,
    p_lead_id: 0,
    l_phase: 0
  });
  const [followUpModal, setFollowUpModal] = useState(false);
  const [followUpData, setFollowUpData] = useState({ u_id: loginUser.u_id });
  const [allocatelist, setallocatelist] = useState([]);
  const [leadData, setLeadData] = useState([]);
  const [leadHistory, setLeadHistory] = useState([]);
  const [expanded, setExpanded] = useState(0);
  const [invoiceData, setInvocieData] = useState([]);
  const [memberOptions, setMemberOptions] = useState([]);
  const [memberSearchLoading, setMemberSearchLoading] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const [memberPage, setMemberPage] = useState(1);
  const [memberTotalRecords, setMemberTotalRecords] = useState(0);
  const [memberSearchTerm, setMemberSearchTerm] = useState("");

  const [convertmemberModal, setConvertMemberModal] = useState(false);
  const [memberdata, setnewmemberdata] = useState({
    pr_payment_mode: 1,
    pr_amount: 0,
    pr_without_gst_amt: 0,
    pr_transaction_id: "",
    m_name: "",
    mobile_no: "",
    m_email_id: "",
    password: ""
  });
  const [isLoading_leadConvertMember, setIsLoading_leadConvertMember] = useState(false);

  const [filterlead, setfilterlead] = useState({
    u_id: loginUser.u_id,
    u_type: loginUser.u_type,
    filterl: "",
    s_date: null,
    e_date: null,
    filteruser: 0,
    l_phase: -1,
    lead_status: -1,
    lead_type: -1
    // user_allocated: 0,
  });
  const [filter, setFilter] = useState({
    defaulselect: { value: 0, label: "All Users" },
    user_id: 0,
    lead_status: -1,
    lead_type: 0
  });
  const [filterOption, setFilterOption] = useState([{ value: 0, label: "All Users" }]);

  const [newleadData, setnewLeadData] = useState([]);
  const [leadtransModal, setLeadTransModal] = useState(false);
  const [leadtransData, setLeadTransData] = useState({ u_id: loginUser.u_id });
  const [rejectmemberModal, setrejectmemberModal] = useState(false);
  const [rejectReasonData, setRejectReasonData] = useState({
    l_r_reason_id: 0
  });
  const [rejectReasonlist, setRejectReasonlist] = useState([]);
  const [isFormSubmit, setIsFormSubmit] = useState(false);

  const [leadStatusChangeModal, setLeadStatusChangeModal] = useState(false);
  const closeLeadStatusChangeModal = () => {
    setLeadStatusChangeModal(false);
    setLeadStatusChangeData({
      p_lead_id: 0, // Lead ID
      l_phase: 0, // Updated Lead Status
      u_id: loginUser?.u_id || 0, // User ID
      from_l_phase: 0, // Old Lead Status
      l_type: ""
    });
  };

  const [leadStatusChangeData, setLeadStatusChangeData] = useState({
    p_lead_id: 0, // Lead ID
    l_phase: 0, // Updated Lead Status
    u_id: loginUser?.u_id || 0, // User ID
    from_l_phase: 0, // Old Lead Status
    l_type: ""
  });

  const statusList = [
    { value: 0, label: "New Signup Lead" },
    { value: 1, label: "Offline Lead" },
    { value: 2, label: "Waiting for Verified" },
    { value: 3, label: "Confirmed" },
    { value: 4, label: "Rejected" }
  ];

  const SearchTypeOptions = [
    { value: -1, label: "All Lead" },
    { value: 0, label: "Signup Lead" },
    { value: 1, label: "Offline Lead" },
    { value: 2, label: "Privilege to Prime" }
  ];

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "60%",
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: "10px"
  };

  const followupstyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: "10px",
    padding: "10px"
  };

  useEffect(async () => {
    getAllPhaseLeads();
    setInvocieData(await getInvoiceSetting());
  }, []);

  const initNewLan = {
    allLeadList: [],
    allLeadIds: [],
    newSignupLead: {
      counter: 0,
      leadList: [],
      id_array: [],
      is_no_more: false
    },
    newOfflineLead: {
      counter: 0,
      leadList: [],
      id_array: [],
      is_no_more: false
    },
    waitingForVerifyLead: {
      counter: 0,
      leadList: [],
      id_array: [],
      is_no_more: false
    },
    confirmedLead: {
      counter: 0,
      leadList: [],
      id_array: [],
      is_no_more: false
    },
    rejectedLead: {
      counter: 0,
      leadList: [],
      id_array: [],
      is_no_more: false
    }
  };
  const [newLan, setNewLan] = useState({
    allLeadList: [],
    allLeadIds: [],
    newSignupLead: {
      counter: 0,
      leadList: [],
      id_array: [],
      is_no_more: false
    },
    newOfflineLead: {
      counter: 0,
      leadList: [],
      id_array: [],
      is_no_more: false
    },
    waitingForVerifyLead: {
      counter: 0,
      leadList: [],
      id_array: [],
      is_no_more: false
    },
    confirmedLead: {
      counter: 0,
      leadList: [],
      id_array: [],
      is_no_more: false
    },
    rejectedLead: {
      counter: 0,
      leadList: [],
      id_array: [],
      is_no_more: false
    }
  });
  const getAllPhaseLeads = async (newState = false) => {
    setIsLoading(true);
    const [newSignupLead, newOfflineLead, waitingForVerifyLead, confirmedLead, rejectedLead] =
      await Promise.all([
        // New Signup Lead
        getPrimeNewLeadList({
          ...(newState ? newState : filterlead),
          l_phase: 0,
          id_array: []
        }),
        // New Offline Lead
        getPrimeNewLeadList({
          ...(newState ? newState : filterlead),
          l_phase: 1,
          id_array: []
        }),
        // Waiting For Payment
        getPrimeNewLeadList({
          ...(newState ? newState : filterlead),
          l_phase: 2,
          id_array: []
        }),
        // Confirm Lead
        getPrimeNewLeadList({
          ...(newState ? newState : filterlead),
          l_phase: 3,
          id_array: []
        }),
        // rejectedLead
        getPrimeNewLeadList({
          ...(newState ? newState : filterlead),
          l_phase: 4,
          id_array: []
        })
      ]);
    setIsLoading(false);

    if (newSignupLead.status == 1) {
      setNewLan((prevState) => updateAPIDataToState(prevState, newSignupLead, "newSignupLead"));
    } else {
      setNewLan((prevState) => prevState);
    }
    if (newOfflineLead.status == 1) {
      setNewLan((prevState) => updateAPIDataToState(prevState, newOfflineLead, "newOfflineLead"));
    } else {
      setNewLan((prevState) => prevState);
    }
    if (confirmedLead.status == 1) {
      setNewLan((prevState) => updateAPIDataToState(prevState, confirmedLead, "confirmedLead"));
    } else {
      setNewLan((prevState) => prevState);
    }
    if (waitingForVerifyLead.status == 1) {
      setNewLan((prevState) =>
        updateAPIDataToState(prevState, waitingForVerifyLead, "waitingForVerifyLead")
      );
    } else {
      setNewLan((prevState) => prevState);
    }
    if (rejectedLead.status == 1) {
      setNewLan((prevState) => updateAPIDataToState(prevState, rejectedLead, "rejectedLead"));
    } else {
      setNewLan((prevState) => prevState);
    }
  };

  const getFilterLeadData = async () => {
    setNewLan({
      allLeadList: [],
      allLeadIds: [],
      newSignupLead: {
        counter: 0,
        leadList: [],
        id_array: [],
        is_no_more: false
      },
      newOfflineLead: {
        counter: 0,
        leadList: [],
        id_array: [],
        is_no_more: false
      },
      waitingForVerifyLead: {
        counter: 0,
        leadList: [],
        id_array: [],
        is_no_more: false
      },
      confirmedLead: {
        counter: 0,
        leadList: [],
        id_array: [],
        is_no_more: false
      },
      rejectedLead: {
        counter: 0,
        leadList: [],
        id_array: [],
        is_no_more: false
      }
    });

    if (filterlead.lead_status != -1) {
      // go for Specific lead Status
      await handleCustomLaneScroll(filterlead.lead_status, true);
    } else {
      // get All Lead
      await getAllPhaseLeads();
    }
  };

  const [exportLeadList, setExportLeadList] = useState([]);
  const [loading, setLoading] = useState(false);
  const exportFilteredLead = async (event, done) => {
    setExportLeadList([]);
    setLoading(true);
    let resp = await getNewPrimeLeadDataForExport({
      ...filterlead,
      type: 0
    });

    if (resp.status == 1) {
      setExportLeadList(resp?.data);
      downloadCSV(resp.data);
    } else {
      let notify = notification({
        type: resp.status == 0 ? "error" : "success",
        message: resp.message
      });
      notify();
    }
    setLoading(false);
  };

  const genderLabel = ["Not Selected", "Male", "Female"];

  const downloadCSV = (data) => {
    // return exportLeadList;
    const csvContent =
      `${expo_columns?.map((column) => column.label).join(",")}\n` +
      `${data
        ?.map((row) =>
          expo_columns
            ?.map((column) => {
              // Convert value to string
              // const value = (row[column.key] || "").toString();
              let value =
                row[column.key] == undefined ||
                  row[column.key] === null ||
                  row[column.key] === "null"
                  ? ""
                  : row[column.key].toString();

              // Special handling for the Followup column
              if (column.key == "follow_ups") {
                // Replace comma with newline for wrap effect
                value = value.replace(/, /g, "\r\n").trim();
              } else if (column.key == "gender") {
                value = genderLabel[Number(value)];
              }

              return `"${value.replace(/"/g, '""')}"`; // Escape double quotes and enclose in quotes
            })
            .join(",")
        )
        .join("\n")}`;
    // `${data
    //   .map((row) =>
    //     expo_columns?.map((column) => row[column.key] || "").join(",")
    //   )
    //   .join("\n")}`;

    // Create Blob from CSV content
    const blob = new Blob(["\uFEFF" + csvContent], { type: "text/csv;charset=utf-8;" });
    // Create URL for the Blob
    const blobUrl = window.URL.createObjectURL(blob);

    // Create anchor element
    const link = document.createElement("a");
    link.setAttribute("href", blobUrl);
    link.setAttribute("download", "LeadList.csv");

    // Append anchor element to the body and trigger click event
    document.body.appendChild(link);
    link.click();

    // Cleanup
    document.body.removeChild(link);
    window.URL.revokeObjectURL(blobUrl);

    // const encodedUri = encodeURI(csvContent);
    // const link = document.createElement("a");
    // link.setAttribute("href", encodedUri);
    // link.setAttribute("download", "LeadList.csv");
    // document.body.appendChild(link);
    // link.click();
    // document.body.removeChild(link);
  };

  const resetSearchForm = async (newState) => {
    setNewLan({
      allLeadList: [],
      allLeadIds: [],
      newSignupLead: {
        counter: 0,
        leadList: [],
        id_array: [],
        is_no_more: false
      },
      newOfflineLead: {
        counter: 0,
        leadList: [],
        id_array: [],
        is_no_more: false
      },
      waitingForVerifyLead: {
        counter: 0,
        leadList: [],
        id_array: [],
        is_no_more: false
      },
      confirmedLead: {
        counter: 0,
        leadList: [],
        id_array: [],
        is_no_more: false
      },
      rejectedLead: {
        counter: 0,
        leadList: [],
        id_array: [],
        is_no_more: false
      }
    });

    await getAllPhaseLeads(newState);
  };

  const updateAPIDataToState = (prevState, newResponse, lead_key) => {
    const { leadList } = newResponse.data;
    const { counter } = newResponse.data;
    return {
      ...prevState,
      ["allLeadList"]: [...prevState["allLeadList"], ...setDataInCard(leadList)],
      ["allLeadIds"]: [
        ...prevState["allLeadIds"],
        ...leadList?.map((lead) => {
          return lead?.p_lead_id;
        })
      ],
      [lead_key]: {
        ...prevState[lead_key],
        counter: counter,
        id_array: [...prevState[lead_key].id_array, ...leadList?.map((lead) => lead.p_lead_id)],
        is_no_more: leadList.length < 20 ? true : false
      }
    };
  };

  const setDataInCard = (list) => {
    return list.map((e, key) => {
      return {
        id: e.p_lead_id,
        l_type: e.l_type,
        taskTitle: e.name,
        createdDate: moment(e.timestamp).format("DD-MM-YYYY hh:mm A"),
        body: e.name,
        contactNo: e.l_contact_no,
        taskCreatedPerson: e.createdBy,
        metadata: { id: e.p_lead_id },
        person: e.allocatedTo,
        phase: e.l_phase,
        tags: {
          cardId: e.p_lead_id,
          priority_Id: e.l_type,
          title:
            e.l_type == 0
              ? "Signup"
              : e.l_type == 1
                ? "Offline"
                : e.l_type == 2
                  ? "Privilege to Prime"
                  : e.l_type == 3
                    ? "Confirm"
                    : ""
        },
        lastElement: key == list.length - 1 ? true : false
      };
    });
  };

  const [loadingMoreData, setLoadingMoreData] = useState(-1);
  const handleCustomLaneScroll = async (laneId, isCallFromSearch = false) => {
    let lead_key =
      laneId == 0
        ? "newSignupLead"
        : laneId == 1
          ? "newOfflineLead"
          : laneId == 2
            ? "waitingForVerifyLead"
            : laneId == 3
              ? "confirmedLead"
              : laneId == 4
                ? "rejectedLead"
                : "";

    if (isCallFromSearch || newLan[lead_key].is_no_more != true) {
      if (loadingMoreData != laneId) {
        setLoadingMoreData(laneId);
        setIsLoading(true);

        let resp = await getPrimeNewLeadList({
          ...filterlead,
          l_phase: laneId,
          id_array: isCallFromSearch ? [] : newLan["allLeadIds"]
        });
        setIsLoading(false);

        if (resp.status == 1) {
          let newDataList = resp.data.leadList;
          let counter = resp.data.counter;
          setNewLan((prevState) => ({
            ...prevState,
            ["allLeadList"]: [...prevState["allLeadList"], ...setDataInCard(newDataList)],
            ["allLeadIds"]: [
              ...prevState["allLeadIds"],
              ...newDataList?.map((lead) => {
                return lead?.p_lead_id;
              })
            ],

            [lead_key]: {
              ...prevState[lead_key],
              counter: counter,
              id_array: [
                ...prevState[lead_key].id_array,
                ...newDataList?.map((lead) => lead.p_lead_id)
              ],
              is_no_more: newDataList.length < 20 ? true : false
            }
          }));
          setLoadingMoreData(-1);
        } else {
          setNewLan((prevState) => prevState);
          setLoadingMoreData(-1);
        }
      }
      setLoadingMoreData(-1);
    }
    setLoadingMoreData(-1);
  };

  useEffect(async () => {
    allocatelist?.map((option) => {
      filterOption.push({ value: option.u_id, label: option.name });
    });
  }, [allocatelist]);

  const getallocatelistbyid = async () => {
    if (loginUser.u_type == 2) {
      setallocatelist(await fetchallocatelistbyid(loginUser.p_user_id, loginUser.u_type));
    } else {
      setallocatelist(await fetchallocatelistbyid(loginUser.u_id, loginUser.u_type));
    }
  };

  const onChangeFunction = (e) => {
    setformdata({ ...formdata, [e.target.name]: e.target.value });
  };

  const fetchMemberOptions = async (search, page = 1) => {
    setMemberSearchLoading(true);
    try {
      const resp = await searchMemberList({ page, per_page: 50, search });
      if (resp.status == 1 && resp.data) {
        setMemberOptions((prev) =>
          page === 1 ? resp.data : [...prev, ...resp.data]
        );
        setMemberTotalRecords(resp.total_records || 0);
        setMemberPage(page);
        setMemberSearchTerm(search);
      } else {
        if (page === 1) setMemberOptions([]);
        setMemberTotalRecords(0);
      }
    } catch {
      if (page === 1) setMemberOptions([]);
      setMemberTotalRecords(0);
    }
    setMemberSearchLoading(false);
  };

  const loadMoreMembers = () => {
    const nextPage = memberPage + 1;
    if (memberOptions.length < memberTotalRecords && !memberSearchLoading) {
      fetchMemberOptions(memberSearchTerm, nextPage);
    }
  };

  const handleMemberSearch = (inputValue, actionMeta) => {
    if (actionMeta.action !== "input-change") return;
    if (window.__leadMemberSearchTimer) clearTimeout(window.__leadMemberSearchTimer);
    window.__leadMemberSearchTimer = setTimeout(() => {
      fetchMemberOptions(inputValue, 1);
    }, 300);
  };

  const getleadlist = async () => {
    setLeadData(await fetchleadlistbyid(loginUser.u_id, loginUser.u_type));
  };

  const getLeadByLeadId = async (l_id) => {
    let res = await getPrimeLeadByLid(l_id);
    setformdata(res);
    if (res?.l_ref_m_id && res?.referral_m_name) {
      setSelectedMember({ label: res.referral_m_name, value: res.l_ref_m_id });
    } else {
      setSelectedMember(null);
    }
    fetchMemberOptions("");
  };

  useEffect(async () => {
    await getallocatelistbyid();
    setRejectReasonlist(await getPrimeLeadRejectReason());
  }, []);

  const [isLoading, setIsLoading] = useState(false);
  const submitformdata = async () => {
    setIsLoading(true);
    // Step 1: Sanitize formdata
    Object.keys(formdata).forEach((key) => {
      if (formdata[key] == "null" || formdata[key] == null) {
        formdata[key] = "";
      }
    });

    // Step 2: Create FormData and append sanitized values
    let fdata = new FormData();
    Object.keys(formdata).forEach((key) => {
      fdata.append(key, formdata[key]);
    });

    if (
      formdata.l_allocated_to == undefined ||
      formdata.l_phase == undefined ||
      // formdata.gender == undefined ||
      // formdata.gender == 0 ||
      formdata.name == undefined ||
      formdata.name == "" ||
      formdata.l_contact_no == undefined ||
      formdata.l_contact_no == "" ||
      formdata.l_email == undefined ||
      formdata.l_email == "" ||
      formdata.date == undefined ||
      formdata.date == ""
    ) {
      let notify = notification({
        type: "error",
        message: "Please Fill Required Fields"
      });
      notify();
      setIsLoading(false);
    } else {
      let resp;

      // Set l_type based on l_phase
      if (formdata.l_phase == 0) {
        fdata.set("l_type", 0); // Signup Lead
      } else {
        fdata.set("l_type", 1); // Offline Lead
      }

      if (step == 1) {
        if (loginUser.u_type == 2) {
          fdata.append("p_u_id", loginUser?.p_user_id);
        } else {
          fdata.append("p_u_id", loginUser?.u_id);
        }
        resp = await insertLead(fdata);
      } else if (step == 2) {
        fdata.append("u_id", loginUser?.u_id);
        fdata.append("edit_from_panel", 0);
        resp = await updatePrimeLeadMemberForm(fdata);
        setIsLoading(false);
      }
      if (resp.status == 1) {
        setStep(0);
        setformdata({ l_created_by: loginUser.u_id, l_type: 0 });
        setSelectedMember(null);

        // Lead API CALL
        setNewLan(initNewLan);
        await getAllPhaseLeads();
      }
      let notify = notification({
        type: resp.status == 0 ? "error" : "success",
        message: resp.message
      });
      notify();
      setIsLoading(false);
    }
  };

  const submitleadtransfer = async () => {
    setIsLoading(true);
    const resp = await leadTransferTO(JSON.stringify(leadtransData));

    if (resp.status == 1) {
      setLeadTransModal(false);
      setLeadTransData({ u_id: loginUser.u_id });
      setLeadHistory(await fetchPrimeleadhistory(myModal.p_lead_id));
      // Lead API CALL
      setNewLan(initNewLan);
      await getAllPhaseLeads();
    }
    setIsLoading(false);
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();
  };

  const submitleadrejectreason = async () => {
    setIsFormSubmit(true);
    if (
      rejectReasonData.l_r_reason_id == 0 ||
      rejectReasonData.l_r_reason_id == "" ||
      rejectReasonData.l_r_reason_id == null ||
      rejectReasonData.l_r_reason_id == undefined
    ) {
      let notify = notification({
        type: "error",
        message: "Please enter all required fields to submit"
      });
      notify();
      setIsFormSubmit(false);
    } else {
      let resp = await insertMemberLeadRejectReason(JSON.stringify(rejectReasonData));
      let notify = notification({
        type: resp.status == 0 ? "error" : "success",
        message: resp.message
      });
      setIsFormSubmit(false);
      notify();
      if (resp.status == 1) {
        let lfdata = new FormData();
        lfdata.append("p_lead_id", rejectReasonData.cardId);
        lfdata.append("l_phase", rejectReasonData.targetLaneId);
        lfdata.append("u_id", loginUser.u_id);
        lfdata.append("from_l_phase", rejectReasonData.sourceLaneId);

        const resp = await updateprimeleadstatus(lfdata);
        let notify = notification({
          type: resp.status == 0 ? "error" : "success",
          message: resp.message
        });
        notify();
        if (resp.status == 1) {
          setIsFormSubmit(false);
          setrejectmemberModal(false);
          setLeadStatusChangeModal(false);
          setRejectReasonData({
            l_r_reason_id: 0
          });

          // Lead API CALL
          setNewLan(initNewLan);
          await getAllPhaseLeads();
        }
      }
    }
  };

  const submitfollowup = async () => {
    setIsFormSubmit(true);
    if (
      followUpData.next_f_date == "" ||
      followUpData.next_f_date == undefined ||
      followUpData.comment == null ||
      followUpData.comment == undefined
    ) {
      let notify = notification({
        type: "error",
        message: "Please enter all required fields to submit"
      });
      notify();
      setIsFormSubmit(false);
    } else {
      setIsLoading(true);
      const resp = await insertFollowUp(JSON.stringify(followUpData));
      setIsLoading(false);
      if (resp.status == 1) {
        setFollowUpModal(false);
        setIsFormSubmit(false);
        setFollowUpData({ u_id: loginUser.u_id });
        setIsLoading(true);
        setLeadHistory(await fetchPrimeleadhistory(myModal.p_lead_id));
        setIsLoading(false);
        // setMyModal(false);
        // setNewLan(initNewLan);
        // await getAllPhaseLeads();
      }
      let notify = notification({
        type: resp.status == 0 ? "error" : "success",
        message: resp.message
      });
      notify();
    }
  };

  const handlememberform = async (e) => {
    // setnewmemberdata({ ...memberdata, [e.target.name]: e.target.value });
    const { name, value } = e.target;

    setnewmemberdata((prev) => ({
      ...prev,
      [name]: value
    }));

    if (name == "pr_payment_mode" && value == "0") {
      setnewmemberdata((prev) => ({
        ...prev,
        pr_amount: invoiceData.data.gst_plan_price,
        pr_without_gst_amt: invoiceData.data.plan_price
      }));
    }

    if (name == "pr_payment_mode" && value == "1") {
      setnewmemberdata((prev) => ({
        ...prev,
        pr_amount: 0,
        pr_without_gst_amt: 0
      }));
    }
  };

  const leadStatusChange = async (cardId, targetLaneId, sourceLaneId) => {
    let resp = await fetchPrimeleadhistory(cardId);
    const lead = resp?.leaddetails;

    // Prevent same-lane movement
    if (targetLaneId === sourceLaneId) return;

    // 🚫 Don't allow Signup lead to go to Offline
    if (lead.l_type == 0 && lead.l_phase == 0 && targetLaneId == 1) {
      let notify = notification({
        type: "error",
        message: "You cannot move a Signup lead to Offline"
      });
      notify();
      setNewLan(initNewLan);
      closeLeadStatusChangeModal();
      await getAllPhaseLeads();
      return;
    }

    // 🚫 Don't allow Offline lead to go to Signup
    if (lead.l_type == 1 && lead.l_phase == 1 && targetLaneId == 0) {
      let notify = notification({
        type: "error",
        message: "You cannot move a Offline lead to Signup"
      });
      notify();
      setNewLan(initNewLan);
      closeLeadStatusChangeModal();
      await getAllPhaseLeads();
      return;
    }

    // 🚫 Don't allow Offline lead to go to Signup & singup lead to go to offline
    if (lead.l_type == 1 && targetLaneId == 0 && sourceLaneId == 2) {
      let notify = notification({
        type: "error",
        message: "You cannot move a Offline lead to Signup"
      });
      notify();
      setNewLan(initNewLan);
      closeLeadStatusChangeModal();
      await getAllPhaseLeads();
      return;
    }
    // 🚫 Don't allow Signup lead to go to Offline & offline lead to go to signup
    if (lead.l_type == 0 && targetLaneId == 1 && sourceLaneId == 2) {
      let notify = notification({
        type: "error",
        message: "You cannot move a Signup lead to Offline"
      });
      notify();
      setNewLan(initNewLan);
      closeLeadStatusChangeModal();
      await getAllPhaseLeads();
      return;
    }

    // 🚫 Role-based restrictions: not allowed to move into some lanes
    if (
      targetLaneId == 3 &&
      (sourceLaneId == 0 || sourceLaneId == 1 || sourceLaneId == 2 || sourceLaneId == 4)
    ) {
      // ✅ Check if another lead exists with same mobile/email and status = 3
      let lfdata = new FormData();
      lfdata.append("p_lead_id", lead.p_lead_id);
      lfdata.append("l_email", lead.l_email);
      lfdata.append("l_contact_no", lead.l_contact_no);
      const duplicateConfirmedLead = await checkDuplicateConfirmedLead(lfdata);

      if (duplicateConfirmedLead.status == 0) {
        let notify = notification({
          type: "error",
          message: duplicateConfirmedLead.message
        });
        notify();
        setNewLan(initNewLan);
        closeLeadStatusChangeModal();
        await getAllPhaseLeads();
        return;
      }
    }

    // ✅ Rejected status handling
    if (lead.l_phase == 3 && targetLaneId == 4 && loginUser?.u_type == 3) {
      let notify = notification({
        type: "error",
        message: "Confirm leads cannot be moved to Rejected phase"
      });
      notify();
      setNewLan(initNewLan);
      closeLeadStatusChangeModal();
      await getAllPhaseLeads();
      return;
    }

    if (targetLaneId == 4 && loginUser?.u_type == 3) {
      setRejectReasonData({
        ...rejectReasonData,
        ...lead,
        cardId: cardId,
        targetLaneId: targetLaneId,
        sourceLaneId: sourceLaneId
      });
      setrejectmemberModal(true);

      // Lead API CALL
      setNewLan(initNewLan);
      closeLeadStatusChangeModal();
      await getAllPhaseLeads();
      return;
    }

    // ✅ Move to New Member
    if (
      targetLaneId == 3 &&
      (sourceLaneId == 0 || sourceLaneId == 1 || sourceLaneId == 2 || sourceLaneId == 4) &&
      (loginUser?.u_type == 3 || (loginUser?.u_type == 2 && loginUser?.management_p == 1))
    ) {
      setnewmemberdata({
        pr_payment_mode: 1,
        pr_amount: 0,
        pr_without_gst_amt: 0,
        pr_transaction_id: "",
        m_name: "",
        mobile_no: "",
        m_email_id: "",
        password: ""
      });

      setConvertMemberModal(true);
      setnewmemberdata({
        ...memberdata,
        ...lead,
        cardId: cardId,
        targetLaneId: targetLaneId,
        sourceLaneId: sourceLaneId
      });

      // New Lead API CALL
      setNewLan(initNewLan);
      closeLeadStatusChangeModal();
      await getAllPhaseLeads();
      return;
    }

    // ✅ Default status update
    let lfdata = new FormData();
    lfdata.append("p_lead_id", cardId);
    lfdata.append("l_phase", targetLaneId);
    lfdata.append("u_id", loginUser.u_id);
    lfdata.append("from_l_phase", sourceLaneId);

    const updateResp = await updateprimeleadstatus(lfdata);
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();
    if (updateResp.status == 1) {
      // New Lead API CALL
      setNewLan(initNewLan);
      closeLeadStatusChangeModal();
      await getAllPhaseLeads();
    }
  };

  const handleChange = (panel) => {
    setExpanded(expanded == panel ? -1 : panel);
  };

  const submitMemberForm = async () => {
    setIsLoading_leadConvertMember(true);
    console.log('memberdata ::<> ', memberdata)
    if (
      // Member Gender
      // memberdata.gender != undefined &&
      // memberdata.gender != 0 &&
      // memberdata.gender != "" &&
      // Member Name
      memberdata.name != undefined &&
      memberdata.name.trim().length != 0 &&
      memberdata.name.trim() != "" &&
      // Password
      memberdata.password != undefined &&
      memberdata.password.trim().length != 0 &&
      memberdata.password.trim() != "" &&
      // Contact Number
      memberdata.l_contact_no != undefined &&
      memberdata.l_contact_no.trim().length != 0 &&
      memberdata.l_contact_no.trim() != "" &&
      // Email
      memberdata.l_email != undefined &&
      memberdata.l_email.trim().length != 0 &&
      memberdata.l_email.trim() != ""
    ) {
      let fndata = new FormData();
      fndata.append("gender", memberdata.gender);
      fndata.append("m_name", memberdata.name);
      fndata.append("mobile_no", memberdata.l_contact_no);
      fndata.append("m_email_id", memberdata.l_email);
      fndata.append("password", memberdata.password);
      fndata.append("type", 6);
      fndata.append("business_name", memberdata?.l_business_name || "");
      fndata.append("business_category", memberdata?.l_business_category || "");
      fndata.append("status", 1);
      fndata.append("is_login", 0);
      fndata.append("pr_occupation_type", memberdata.occupation_type);
      fndata.append("pr_p_status", 2);
      fndata.append("pr_payment_mode", memberdata.pr_payment_mode);
      fndata.append("pr_welcome_kit_status", memberdata.pr_payment_mode == 1 ? 3 : 0);
      fndata.append("pr_amount", memberdata.pr_amount);
      fndata.append("pr_without_gst_amt", memberdata.pr_without_gst_amt);
      fndata.append("pr_transaction_id", memberdata.pr_transaction_id);
      fndata.append("joining_date", moment().format("DD-MM-YYYY"));
      fndata.append("pr_reg_date", memberdata.reg_date);
      fndata.append("p_lead_id", memberdata.cardId);
      fndata.append("l_phase", memberdata.targetLaneId);
      fndata.append("l_type", memberdata.l_type);
      fndata.append("from_l_phase", memberdata.sourceLaneId);
      fndata.append("from_type", 0);
      fndata.append("pr_m_address", formdata.pr_m_address ? formdata.pr_m_address : "");
      fndata.append("pr_reference", memberdata.l_reference ? memberdata.l_reference : "");
      fndata.append("l_district", memberdata.l_district ? memberdata.l_district : "");
      fndata.append("l_taluka", memberdata.l_taluka ? memberdata.l_taluka : "");
      fndata.append("l_village", memberdata.l_village ? memberdata.l_village : "");
      fndata.append("b_address", formdata.pr_m_address ? formdata.pr_m_address : "");
      fndata.append("r_m_id", memberdata.r_m_id);
      fndata.append("l_ref_m_id", memberdata.l_ref_m_id);
      fndata.append("m_referral_code", memberdata.m_referral_code);
      let resp = await insertPrimeMember(fndata);
      setIsLoading_leadConvertMember(false);
      let notify = notification({
        type: resp.status == 0 ? "error" : "success",
        message: resp.message
      });
      notify();
      if (resp.status == 1) {
        let lfdata = new FormData();
        lfdata.append("p_lead_id", memberdata.cardId);
        lfdata.append("l_ref_m_id", memberdata.l_ref_m_id);
        lfdata.append("l_phase", memberdata.targetLaneId);
        lfdata.append("u_id", loginUser.u_id);
        lfdata.append("from_l_phase", memberdata.sourceLaneId);
        lfdata.append("member_id", resp.member_id);

        const leadstatusresp = await updateprimeleadstatus(lfdata);
        let notify = notification({
          type: leadstatusresp.status == 0 ? "error" : "success",
          message: leadstatusresp.message
        });
        notify();
        setIsLoading_leadConvertMember(false);
        if (leadstatusresp.status == 1) {
          setConvertMemberModal(false);
          closeLeadStatusChangeModal();
          setnewmemberdata({
            pr_payment_mode: 1,
            pr_amount: 0,
            pr_without_gst_amt: 0,
            pr_transaction_id: "",
            m_name: "",
            mobile_no: "",
            m_email_id: "",
            password: ""
          });
          setNewLan(initNewLan);
          await getAllPhaseLeads();
        }
      }
    } else {
      let notify = notification({
        type: "error",
        message: `Please Fill All Required Information In Form`
      });
      notify();
      setIsLoading_leadConvertMember(false);
    }
  };

  // KanBan Board
  let len = [[], [], [], [], [], [], [], []];
  newleadData?.map((e, key) => {
    let temp = {
      id: e.p_lead_id,
      l_type: e.l_type,
      taskTitle: e.name,
      createdDate: moment(e.timestamp).format("DD-MM-YYYY hh:mm A"),
      body: e.name,
      contactNo: e.l_contact_no,
      taskCreatedPerson: e.createdBy,
      metadata: { id: e.p_lead_id },
      person: e.allocatedTo,
      phase: e.l_phase,
      tags: {
        cardId: e.p_lead_id,
        priority_Id: e.l_type,
        title:
          e.l_type == 0
            ? "Signup"
            : e.l_type == 1
              ? "Offline"
              : e.l_type == 2
                ? "Privilege to Prime"
                : e.l_type == 3
                  ? "Confirm"
                  : ""
      }
    };
    if (e.l_phase == 4) {
      len[e.l_phase].push(temp);
    } else {
      len[e.l_phase].push(temp);
    }
  });

  const leadList = {
    lanes: [
      {
        id: "0",
        title: "Signup Lead",
        className: "taskListColumn openTask",
        cards: newLan.allLeadList.filter((item) => item.phase == 0),
        label: newLan.newSignupLead.counter,
        currentPage: 1,
        style: { position: "relative" }
      },
      {
        id: "1",
        title: "Offline Lead",
        className: "taskListColumn openTask",
        cards: newLan.allLeadList.filter((item) => item.phase == 1),
        label: newLan.newOfflineLead.counter,
        currentPage: 1,
        style: { position: "relative" }
      },
      {
        id: "2",
        title: "Waiting for Verify",
        className: "taskListColumn finishTask",
        cards: newLan.allLeadList.filter((item) => item.phase == 2),
        label: newLan.waitingForVerifyLead.counter,
        currentPage: 1,
        style: { position: "relative" }
      },
      {
        id: "3",
        title: "Confirm",
        className: "taskListColumn inReviewTask",
        cards: newLan.allLeadList.filter((item) => item.phase == 3),
        label: newLan.confirmedLead.counter,
        currentPage: 1,
        style: { position: "relative" }
      },
      {
        id: "4",
        title: "Rejected",
        className: "taskListColumn rejectedTask",
        cards: newLan.allLeadList.filter((item) => item.phase == 4),
        label: newLan?.rejectedLead?.counter || 0,
        currentPage: 1,
        style: { position: "relative" }
      }
    ]
  };

  const CustomCard = ({
    onClick,
    taskTitle,
    body,
    contactNo,
    createdDate,
    subTitle,
    taskCreatedPerson,
    tags,
    showDeleteButton,
    onDelete,
    person,
    phase,
    l_type,
    id,
    lastElement
  }) => {
    const clickDelete = (e) => {
      onDelete();
      e.stopPropagation();
    };

    const handleRightClick = (e) => { };

    return (
      <>
        <div
          id={id}
          phase={phase}
          l_type={l_type}
          className="myCard"
          style={{ position: "relative" }}
        >
          <div className="taskCard" style={{ position: "relative" }}>
            <div>
              <header
                className="taskHeader"
                style={{ paddingBottom: "8px" }}
                onClick={() => {
                  setLeadStatusChangeData({
                    ...leadStatusChangeData,
                    p_lead_id: id,
                    l_type: l_type,
                    from_l_phase: phase
                  });
                  setLeadStatusChangeModal(true);
                  // setDvisible({ mval: true, id: id });
                }}
              >
                <div className="TaskTitle">{taskTitle}</div>
                <a
                  className=""
                  style={{ position: "absolute", right: "0px", zIndex: "0" }}
                  onClick={() => {
                    setLeadStatusChangeData({
                      ...leadStatusChangeData,
                      p_lead_id: id,
                      l_type: l_type,
                      from_l_phase: phase
                    });
                    setLeadStatusChangeModal(true);
                    // setDvisible({ mval: true, id: id });
                  }}
                >
                  <Tooltip title="Change Lead Status" style={{ padding: 0, margin: 0 }}>
                    <IconButton>
                      <ChangeCircle color="success" style={{ height: "20px", width: "20px" }} />
                    </IconButton>
                  </Tooltip>
                </a>
                {showDeleteButton && <div onClick={clickDelete} />}
              </header>
              <div className="taskBody" onContextMenu={handleRightClick} onClick={onClick}>
                {/* <div>{subTitle}</div> */}
                <p>
                  <b>Name : </b> {taskTitle}
                </p>
                <p>
                  <b>Contact : </b> {contactNo}
                </p>
              </div>
              <div className="taskUserDetail">
                <div className="taskCreatedName">
                  <b>Assign To : {person}</b>
                </div>
                <div className="taskDate">
                  <p>
                    <b>Lead Date :</b> {createdDate}
                  </p>
                </div>
              </div>
            </div>
            <div className="taskFooter">
              <div>
                <p style={{ fontSize: "14px", fontWeight: "bold" }}>{taskCreatedPerson}</p>
              </div>
              <div>
                <a
                  key={tags.title}
                  {...tags}
                  className="taskPriority"
                  attendance_status={tags.attendance_status}
                // onClick={() => {
                //   alert("hii");
                // }}
                >
                  {tags.title}
                </a>
              </div>
            </div>
          </div>
        </div>

        {loadingMoreData == phase && lastElement ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <CircularProgress color="primary" fourColor variant="indeterminate" />
          </div>
        ) : (
          <></>
        )}
      </>
    );
  };

  const cancelModal = () => {
    setMyModal({ mval: false, p_lead_id: 0, l_phase: 0 });
    setFollowUpModal(false);
    setLeadTransModal(false);
    setConvertMemberModal(false);
  };

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  const expo_columns = [
    { label: "No", key: "p_lead_id" },
    { label: "Lead Date", key: "date" },
    { label: "Type", key: "lead_type" },
    { label: "Gender", key: "gender" },
    { label: "Name", key: "name" },
    { label: "Followup", key: "follow_ups" },
    { label: "Contact No", key: "l_contact_no" },
    { label: "Business Name", key: "l_business_name" },
    { label: "Business Category", key: "l_business_category" },
    { label: "Address", key: "l_address" },
    { label: "Occupation Type", key: "occupation_type" },
    { label: "Email Id", key: "l_email" },
    { label: "Reference", key: "l_reference" },
    { label: "District", key: "l_district" },
    { label: "Taluka", key: "l_taluka" },
    { label: "Village", key: "l_village" },
    { label: "Created By", key: "createdBy" },
    { label: "Allocated To", key: "allocatedTo" },
    { label: "Phase", key: "lead_phase" },
    { label: "Reject Reason", key: "lead_reject_reason" }
  ];

  const columns = [
    {
      name: "No",
      wrap: true,
      selector: (row) => row.p_lead_id,
      sortable: true,
      width: "70px"
    },
    {
      name: "Date",
      wrap: true,
      selector: (row) => row.date
    },
    {
      name: "Type",
      wrap: true,
      selector: (row) =>
        row.l_type == 0
          ? "Signup"
          : row.l_type == 1
            ? "Offline"
            : row.l_type == 2
              ? "Privilege to Prime"
              : row.l_type == 3
                ? "Confirm Member"
                : ""
    },
    {
      name: "Name",
      wrap: true,
      selector: (row) => row.name
    },

    {
      name: "Contact No",
      wrap: true,
      selector: (row) => row.l_contact_no
    },
    {
      name: "Created By",
      wrap: true,
      selector: (row) => row.createdBy
    },
    {
      name: "Allocated To",
      wrap: true,
      selector: (row) => row.allocatedTo
    },
    {
      name: "Phase",
      wrap: true,
      selector: (row) => (
        <>
          {statusList &&
            statusList?.map((k) => {
              if (k.value == row.l_phase) {
                return k.label;
              }
            })}
        </>
      ),
      sortable: true
    }
  ];

  const [activeTab, setActiveTab] = useState(1);

  return (
    <>
      <Modal
        style={{ overflow: "scroll" }}
        open={myModal.mval}
        onClose={cancelModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography
            id="modal-modal-title"
            variant="div"
            component="div"
            style={{
              margin: "10px",
              textAlign: "center",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }}
          >
            <div style={{ width: "100%" }}>
              <Tooltip
                title="Edit Lead"
                onClick={async () => {
                  await getLeadByLeadId(myModal.p_lead_id);
                  await cancelModal();
                  await setStep(2);
                }}
              >
                <IconButton>
                  <EditSharp color="warning" />
                </IconButton>
              </Tooltip>
              {[0, 1, 2].includes(leadHistory?.leaddetails?.l_phase) && (
                <Tooltip
                  title="Add Followup"
                  onClick={async () => {
                    await setFollowUpData({
                      ...followUpData,
                      p_lead_id: myModal.p_lead_id
                    });
                    await setFollowUpModal(true);
                  }}
                >
                  <IconButton>
                    <SendSharp color="info" />
                  </IconButton>
                </Tooltip>
              )}
              <Tooltip
                title="Transfer Lead"
                onClick={async () => {
                  await setLeadTransData({
                    ...leadtransData,
                    p_lead_id: myModal.p_lead_id
                  });
                  await setLeadTransModal(true);
                }}
              >
                <IconButton>
                  <PersonAddAltSharp color="success" />
                </IconButton>
              </Tooltip>
            </div>

            <div>
              <Tooltip
                title="Close"
                onClick={async () => {
                  await cancelModal();
                  setValue("1");
                }}
              >
                <IconButton>
                  <Close color="blank" />
                </IconButton>
              </Tooltip>
            </div>
          </Typography>
          <TabContext value={value}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList onChange={handleTabChange} aria-label="lab API tabs example" centered>
                <Tab
                  icon={<LeaderboardSharp />}
                  iconPosition="end"
                  label="Lead Details"
                  value="1"
                />
                <Tab icon={<ThumbUpAlt />} iconPosition="end" label="Follow Up History" value="3" />
                <Tab icon={<AutoGraphSharp />} iconPosition="end" label="Activity Log" value="2" />
              </TabList>
            </Box>
            <div
              style={{
                maxHeight: "500px",
                height: "500px",
                overflowY: "scroll"
              }}
            >
              <TabPanel value="1">
                <>
                  <Grid container spacing={2}>
                    <Grid xs={8} item>
                      {/* Personal Details Card */}
                      <Card style={{ border: "1px solid #abababb5" }}>
                        <div>
                          <h3
                            style={{
                              padding: "15px",
                              background: "#1c4766",
                              color: "#fff"
                            }}
                          >
                            Personal Information
                          </h3>
                          <Grid container spacing={0}>
                            <Grid xs={6} item>
                              <div
                                style={{
                                  margin: "5px 15px",
                                  paddingBottom: "5px",
                                  borderBottom: "1px solid #abababb5"
                                }}
                              >
                                <h4 style={{ color: "#838383" }}>Gender </h4>
                                <p className="word-break-all">
                                  {gender?.find((g) => g.value === leadHistory?.leaddetails?.gender)
                                    ?.label || "-"}
                                </p>
                              </div>
                            </Grid>
                            <Grid xs={6} item>
                              <div
                                style={{
                                  margin: "5px 15px",
                                  paddingBottom: "5px",
                                  borderBottom: "1px solid #abababb5"
                                }}
                              >
                                <h4 style={{ color: "#838383" }}>Name </h4>
                                <p className="word-break-all">
                                  {leadHistory?.leaddetails?.name || "-"}
                                </p>
                              </div>
                            </Grid>
                            <Grid xs={6} item>
                              <div
                                style={{
                                  margin: "5px 15px",
                                  paddingBottom: "5px",
                                  borderBottom: "1px solid #abababb5"
                                }}
                              >
                                <h4 style={{ color: "#838383" }}>DOB </h4>
                                <p className="word-break-all">
                                  {leadHistory?.leaddetails?.dob || "-"}
                                </p>
                              </div>
                            </Grid>
                            <Grid xs={6} item>
                              <div
                                style={{
                                  margin: "5px 15px",
                                  paddingBottom: "5px",
                                  borderBottom: "1px solid #abababb5"
                                }}
                              >
                                <h4 style={{ color: "#838383" }}>Contact No </h4>
                                <p className="word-break-all">
                                  {leadHistory?.leaddetails?.l_contact_no || "-"}
                                </p>
                              </div>
                            </Grid>
                            <Grid xs={6} item>
                              <div
                                style={{
                                  margin: "5px 15px",
                                  paddingBottom: "5px",
                                  borderBottom: "1px solid #abababb5"
                                }}
                              >
                                <h4 style={{ color: "#838383" }}>Alternate Contact No </h4>
                                <p className="word-break-all">
                                  {leadHistory?.leaddetails?.alternate_contact_number || "-"}
                                </p>
                              </div>
                            </Grid>
                          </Grid>
                        </div>
                      </Card>

                      {/* Business Details Card */}
                      <Card
                        style={{
                          border: "1px solid #abababb5",
                          marginTop: "15px"
                        }}
                      >
                        <div>
                          <h3
                            style={{
                              padding: "15px",
                              background: "#1c4766",
                              color: "#fff"
                            }}
                          >
                            Business Information
                          </h3>
                          <Grid container spacing={0}>
                            <Grid xs={6} item>
                              <div
                                style={{
                                  margin: "5px 15px",
                                  paddingBottom: "5px",
                                  borderBottom: "1px solid #abababb5"
                                }}
                              >
                                <h4 style={{ color: "#838383" }}>Business Name</h4>
                                <p className="word-break-all">
                                  {leadHistory?.leaddetails?.l_business_name || "-"}
                                </p>
                              </div>
                            </Grid>

                            <Grid xs={6} item>
                              <div
                                style={{
                                  margin: "5px 15px",
                                  paddingBottom: "5px",
                                  borderBottom: "1px solid #abababb5"
                                }}
                              >
                                <h4 style={{ color: "#838383" }}>Business Category</h4>
                                <p className="word-break-all">
                                  {leadHistory?.leaddetails?.l_business_category || "-"}
                                </p>
                              </div>
                            </Grid>
                            <Grid xs={6} item>
                              <div
                                style={{
                                  margin: "5px 15px",
                                  paddingBottom: "5px",
                                  borderBottom: "1px solid #abababb5"
                                }}
                              >
                                <h4 style={{ color: "#838383" }}>Email ID</h4>
                                <p className="word-break-all">
                                  {leadHistory?.leaddetails?.l_email || "-"}
                                </p>
                              </div>
                            </Grid>
                            <Grid xs={6} item>
                              <div
                                style={{
                                  margin: "5px 15px",
                                  paddingBottom: "5px",
                                  borderBottom: "1px solid #abababb5"
                                }}
                              >
                                <h4 style={{ color: "#838383" }}>Office Address</h4>
                                <p className="word-break-all">
                                  {leadHistory?.leaddetails?.l_address || "-"}
                                </p>
                              </div>
                            </Grid>
                          </Grid>
                        </div>
                      </Card>
                      {(leadHistory?.leaddetails?.l_district ||
                        leadHistory?.leaddetails?.l_taluka ||
                        leadHistory?.leaddetails?.l_village) && (
                          <Card
                            style={{
                              border: "1px solid #abababb5",
                              marginTop: "15px"
                            }}
                          >
                            <div>
                              <h3
                                style={{
                                  padding: "15px",
                                  background: "#1c4766",
                                  color: "#fff"
                                }}
                              >
                                Location Information
                              </h3>
                              <Grid container spacing={0}>
                                <Grid xs={6} item>
                                  <div
                                    style={{
                                      margin: "5px 15px",
                                      paddingBottom: "5px",
                                      borderBottom: "1px solid #abababb5"
                                    }}
                                  >
                                    <h4 style={{ color: "#838383" }}>District</h4>
                                    <p className="word-break-all">
                                      {leadHistory?.leaddetails?.l_district || "-"}
                                    </p>
                                  </div>
                                </Grid>
                                <Grid xs={6} item>
                                  <div
                                    style={{
                                      margin: "5px 15px",
                                      paddingBottom: "5px",
                                      borderBottom: "1px solid #abababb5"
                                    }}
                                  >
                                    <h4 style={{ color: "#838383" }}>Taluka</h4>
                                    <p className="word-break-all">
                                      {leadHistory?.leaddetails?.l_taluka || "-"}
                                    </p>
                                  </div>
                                </Grid>
                                <Grid xs={6} item>
                                  <div
                                    style={{
                                      margin: "5px 15px",
                                      paddingBottom: "5px",
                                      borderBottom: "1px solid #abababb5"
                                    }}
                                  >
                                    <h4 style={{ color: "#838383" }}>Village</h4>
                                    <p className="word-break-all">
                                      {leadHistory?.leaddetails?.l_village || "-"}
                                    </p>
                                  </div>
                                </Grid>
                              </Grid>
                            </div>
                          </Card>
                        )}
                    </Grid>

                    {/* Right Side  */}
                    <Grid xs={4} item>
                      <div style={{ position: "sticky", top: "10px" }}>
                        <Card
                          style={{
                            border: "1px solid #abababb5"
                          }}
                        >
                          <div>
                            <h3
                              style={{
                                padding: "15px",
                                background: "#1c4766",
                                color: "#fff"
                              }}
                            >
                              Lead Information
                            </h3>
                            <div>
                              <div
                                style={{
                                  margin: "5px 15px",
                                  paddingBottom: "5px",
                                  borderBottom: "1px solid #abababb5"
                                }}
                              >
                                <h4 style={{ color: "#838383" }}>Date </h4>
                                <p className="word-break-all">{moment(leadHistory?.leaddetails?.timestamp).format("DD-MM-YYYY hh:mm A")}</p>
                              </div>
                              <div
                                style={{
                                  margin: "5px 15px",
                                  paddingBottom: "5px",
                                  borderBottom: "1px solid #abababb5"
                                }}
                              >
                                <h4 style={{ color: "#838383" }}>Lead Type </h4>
                                <p className="word-break-all">
                                  {leadHistory?.leaddetails?.l_type == 0
                                    ? "Signup"
                                    : leadHistory?.leaddetails?.l_type == 1
                                      ? "Offline"
                                      : leadHistory?.leaddetails?.l_type == 2
                                        ? "Privilege to Prime"
                                        : leadHistory?.leaddetails?.l_type == 3
                                          ? "Confirm"
                                          : ""}
                                </p>
                              </div>
                              <div
                                style={{
                                  margin: "5px 15px",
                                  paddingBottom: "5px",
                                  borderBottom: "1px solid #abababb5"
                                }}
                              >
                                <h4 style={{ color: "#838383" }}>Lead Status </h4>
                                <p className="word-break-all">
                                  {statusList?.map((e) => {
                                    if (e.value == leadHistory?.leaddetails?.l_phase) {
                                      return e.label;
                                    }
                                  })}
                                </p>
                              </div>
                              <div
                                style={{
                                  margin: "5px 15px",
                                  paddingBottom: "5px",
                                  borderBottom: "1px solid #abababb5"
                                }}
                              >
                                <h4 style={{ color: "#838383" }}>Reject Reason </h4>
                                <p className="word-break-all">
                                  {leadHistory?.leaddetails?.lead_reject_reason}
                                </p>
                              </div>
                              <div
                                style={{
                                  margin: "5px 15px",
                                  paddingBottom: "5px",
                                  borderBottom: "1px solid #abababb5"
                                }}
                              >
                                <h4 style={{ color: "#838383" }}>Allocated To</h4>
                                <p className="word-break-all">
                                  {leadHistory?.leaddetails?.allocatedTo}
                                </p>
                              </div>
                              <div
                                style={{
                                  margin: "5px 15px",
                                  paddingBottom: "5px",
                                  borderBottom: "1px solid #abababb5"
                                }}
                              >
                                <h4 style={{ color: "#838383" }}>Created By </h4>
                                <p className="word-break-all">
                                  {leadHistory?.leaddetails?.createdBy}
                                </p>
                              </div>
                              <div
                                style={{
                                  margin: "5px 15px",
                                  paddingBottom: "5px",
                                  borderBottom: "1px solid #abababb5"
                                }}
                              >
                                <h4 style={{ color: "#838383" }}>{leadHistory?.leaddetails?.m_referral_code ? 'Referral By' : 'Reference By'}</h4>
                                <p className="word-break-all">
                                  {leadHistory?.leaddetails?.referral_m_name}
                                </p>
                              </div>
                            </div>
                          </div>
                        </Card>
                      </div>
                    </Grid>
                  </Grid>
                </>
              </TabPanel>
              <TabPanel value="3">
                <>
                  {leadHistory?.followupdetails?.map((e, key) => {
                    return (
                      <Accordion
                        style={{
                          boxShadow: "#0000003d 0px 0px 6px 0px",
                          marginBottom: "10px",
                          borderRadius: "11px",
                          border: "1px solid #1c47669c"
                        }}
                        expanded={expanded === key}
                        onChange={() => handleChange(key)}
                      >
                        <AccordionSummary
                          style={{
                            background: "#1c4766",
                            color: "#fff",
                            borderRadius: "10px"
                          }}
                          aria-controls="panel1d-content"
                          id={key}
                        // panel1d-header
                        >
                          <Typography>{e.userName + " ( " + e.date + " )"}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography>
                            <p>Next Follow Date : {e.next_f_date}</p>
                            <p>Comment : {e.comment}</p>
                          </Typography>
                        </AccordionDetails>
                      </Accordion>
                    );
                  })}
                </>
              </TabPanel>
              <TabPanel value="2">
                <Timeline position="right">
                  {leadHistory?.activitylog?.map((e) => {
                    return (
                      <TimelineItem>
                        <TimelineOppositeContent
                          color="text.secondary"
                          style={{
                            textAlign: "left",
                            width: "150px",
                            maxWidth: "150px"
                          }}
                        >
                          {e.date}
                        </TimelineOppositeContent>
                        <TimelineSeparator>
                          <TimelineDot color="primary" />
                          <TimelineConnector />
                        </TimelineSeparator>
                        <TimelineContent style={{ wordBreak: "break-word" }}>
                          <h4>{e.userName}</h4>
                          <p>{e.l_a_description}</p>
                        </TimelineContent>
                      </TimelineItem>
                    );
                  })}
                </Timeline>
              </TabPanel>
            </div>
          </TabContext>
        </Box>
      </Modal>
      <Modal
        open={followUpModal}
        onClose={cancelModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={followupstyle}>
          <Typography
            align="center"
            id="modal-modal-title"
            variant="h4"
            component="h2"
            style={{ borderBottom: "2px solid #000" }}
          >
            Follow Up
          </Typography>
          <div style={{ padding: "10px" }}>
            <div style={{ maxHeight: "320px" }}>
              <Stack spacing={10} style={{ marginBottom: "15px" }}>
                <Card style={{ padding: "25px", paddingBottom: "25px" }}>
                  <Stack spacing={10} style={{ marginBottom: "15px" }}>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <Stack spacing={3}>
                          {/* <label style={{ marginBottom: '10px' }}>Join Date</label> */}
                          <LocalizationProvider
                            dateAdapter={AdapterDateFns}
                            adapterLocale={enGB}
                            style={{ marginTop: "15px" }}
                          >
                            <DatePicker
                              type="date"
                              name="next_f_date"
                              label="Next FollowUp date"
                              inputFormat="dd/MM/yyyy"
                              value={
                                followUpData.next_f_date
                                  ? new Date(
                                    followUpData.next_f_date.split("-").reverse().join("-")
                                  ) // Converts "DD-MM-YYYY" to "YYYY-MM-DD"
                                  : null
                              }
                              onChange={(newDate) => {
                                if (newDate instanceof Date && !isNaN(newDate)) {
                                  const day = String(newDate.getDate()).padStart(2, "0");
                                  const month = String(newDate.getMonth() + 1).padStart(2, "0");
                                  const year = newDate.getFullYear();
                                  setFollowUpData({
                                    ...followUpData,
                                    next_f_date: `${day}-${month}-${year}`
                                  });
                                }
                              }}
                              renderInput={(params) => <TextField {...params} fullWidth />}
                            />
                          </LocalizationProvider>
                        </Stack>
                      </Grid>
                      <Grid item xs={12}>
                        <Stack spacing={3} style={{ marginBottom: "15px" }}>
                          <TextField
                            multiline
                            rows={4}
                            fullWidth
                            label="Comment"
                            name="comment"
                            value={followUpData?.comment || ""}
                            onChange={(e) => {
                              setFollowUpData({
                                ...followUpData,
                                comment: e.target.value
                              });
                            }}
                          />
                        </Stack>
                      </Grid>
                    </Grid>
                  </Stack>
                </Card>
              </Stack>
            </div>
            <hr />
            <div
              style={{
                margin: "10px auto",
                display: "flex",
                justifyContent: "space-between"
              }}
            >
              <Button
                variant="outlined"
                onClick={() => {
                  setFollowUpModal(false);
                }}
              >
                Close
              </Button>
              <Button
                variant="contained"
                onClick={submitfollowup}
                disabled={isLoading}
                startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
              >
                Confirm
              </Button>
            </div>
          </div>
        </Box>
      </Modal>
      <Modal
        open={leadtransModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={followupstyle}>
          <Typography
            align="center"
            id="modal-modal-title"
            variant="h4"
            component="h2"
            style={{ borderBottom: "2px solid #000" }}
          >
            Lead Transfer
          </Typography>
          <div style={{ padding: "10px" }}>
            <div style={{ maxHeight: "320px" }}>
              <Stack spacing={10} style={{ marginBottom: "15px" }}>
                <Stack spacing={10} style={{ marginBottom: "15px" }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <Stack spacing={10} style={{ marginBottom: "15px" }}>
                        <label style={{ marginBottom: "10px" }}>Transer To</label>
                        <Select
                          value={
                            allocatelist &&
                            allocatelist
                              ?.map((p) => {
                                if (p.u_id == leadtransData.l_transfer_to) {
                                  return { value: p.u_id, label: p.u_name };
                                }
                              })
                              .filter((n) => n)[0]
                          }
                          style={{ marginTop: "0px" }}
                          name="l_transfer_to"
                          onChange={(e) => {
                            setLeadTransData({
                              ...leadtransData,
                              l_transfer_to: e.value
                            });
                          }}
                          options={
                            allocatelist != null &&
                            allocatelist?.map((p) => {
                              return { value: p.u_id, label: p.u_name };
                            })
                          }
                        ></Select>
                      </Stack>
                    </Grid>
                  </Grid>
                </Stack>
              </Stack>
            </div>
            <hr />
            <div
              style={{
                margin: "10px auto",
                display: "flex",
                justifyContent: "space-between"
              }}
            >
              <Button
                variant="outlined"
                onClick={() => {
                  setLeadTransModal(false);
                }}
              >
                Close
              </Button>
              <Button
                variant="contained"
                onClick={submitleadtransfer}
                disabled={isLoading}
                startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
              >
                Confirm
              </Button>
            </div>
          </div>
        </Box>
      </Modal>
      <Modal
        open={rejectmemberModal}
        onClose={() => setrejectmemberModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={followupstyle}>
          <Typography
            align="center"
            id="modal-modal-title"
            variant="h4"
            component="h2"
            style={{ borderBottom: "2px solid #000" }}
          >
            Lead Reject Reason
          </Typography>
          <div style={{ padding: "10px" }}>
            <div style={{ maxHeight: "320px" }}>
              <Stack spacing={10} style={{ marginBottom: "15px" }}>
                <Stack spacing={10} style={{ marginBottom: "15px" }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <Stack spacing={10} style={{ marginBottom: "15px" }}>
                        {/* <TextField
                          style={{ marginTop: "0px" }}
                          fullWidth
                          multiline
                          rows={5}
                          autoComplete="off"
                          type="text"
                          label="Reason"
                          name="member_renewal_reject_reason"
                          value={rejectReasonData?.member_renewal_reject_reason}
                          onChange={(e) => {
                            setRejectReasonData({
                              ...rejectReasonData,
                              member_renewal_reject_reason: e.target.value,
                            });
                          }}
                        /> */}
                        <label style={{ marginBottom: "10px" }}>Select Reject Reason</label>
                        <Select
                          value={
                            rejectReasonlist &&
                            rejectReasonlist
                              ?.map((p) => {
                                if (p.l_r_reason_id == rejectReasonData.l_r_reason_id) {
                                  return { value: p.l_r_reason_id, label: p.lead_reject_reason };
                                }
                              })
                              .filter((n) => n)[0]
                          }
                          style={{ marginTop: "0px" }}
                          name="l_r_reason_id"
                          onChange={(e) => {
                            setRejectReasonData({
                              ...rejectReasonData,
                              l_r_reason_id: e.value
                            });
                          }}
                          options={
                            rejectReasonlist != null &&
                            rejectReasonlist?.map((p) => {
                              return { value: p.l_r_reason_id, label: p.lead_reject_reason };
                            })
                          }
                        ></Select>
                      </Stack>
                    </Grid>
                  </Grid>
                </Stack>
              </Stack>
            </div>
            <hr />
            <div
              style={{
                margin: "10px auto",
                display: "flex",
                justifyContent: "space-between"
              }}
            >
              <Button
                variant="outlined"
                onClick={() => {
                  setrejectmemberModal(false);
                }}
              >
                Close
              </Button>
              <Button
                variant="contained"
                onClick={submitleadrejectreason}
                disabled={isFormSubmit}
                startIcon={isFormSubmit && <CircularProgress size={20} color="inherit" />}
              >
                Confirm
              </Button>
            </div>
          </div>
        </Box>
      </Modal>
      <Modal
        open={leadStatusChangeModal}
        onClose={closeLeadStatusChangeModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={followupstyle}>
          <Typography
            align="center"
            id="modal-modal-title"
            variant="h4"
            component="h2"
            style={{ borderBottom: "2px solid #000" }}
          >
            Update Lead Status
          </Typography>
          <div style={{ padding: "10px" }}>
            {statusList?.map((status) => {
              const currentPhase = leadStatusChangeData?.from_l_phase;
              const currentType = leadStatusChangeData?.l_type;
              const targetPhase = status?.value;

              // Block: Offline → Signup
              // Block: Signup → Offline
              const isDisabled = (() => {
                if (currentType == 1 && targetPhase == 0) return true; // Block any Offline → Signup
                if (currentType == 0 && targetPhase == 1) return true; // Block any Signup → Offline
                if (currentPhase == 2 && currentType == 1 && targetPhase == 0) return true;
                if (currentPhase == 2 && currentType == 0 && targetPhase == 1) return true;
                if (currentPhase == 3 && targetPhase == 4) return true;
                return false;
              })();

              return (
                <div
                  value={status?.value}
                  style={{
                    position: "relative",
                    marginBottom: "10px",
                    border:
                      currentPhase === status?.value
                        ? "none"
                        : isDisabled
                          ? "2px dashed gray"
                          : "2px solid #1c4766",
                    padding: "7px 15px",
                    borderRadius: "10px",
                    background:
                      currentPhase === status?.value ? "#1c4766" : isDisabled ? "#f5f5f5" : "#fff",
                    color: currentPhase === status?.value ? "#fff" : isDisabled ? "#aaa" : "#000",
                    cursor: isDisabled ? "not-allowed" : "pointer",
                    pointerEvents: isDisabled ? "none" : "auto",
                    WebkitUserSelect: "none", // Optional: Disable text selection on double-click
                    MozUserSelect: "none", // Optional: Disable text selection on double-click
                    msUserSelect: "none", // Optional: Disable text selection on double-click
                    userSelect: "none" // Optional: Disable text selection on double-click
                  }}
                  onClick={async (e) => {
                    const divValue = e.currentTarget.getAttribute("value");
                    await leadStatusChange(
                      leadStatusChangeData.p_lead_id,
                      divValue,
                      leadStatusChangeData.from_l_phase
                    );
                  }}
                >
                  <a id="">{status.label}</a>
                  {currentPhase === status?.value && (
                    <Check color="#fff" style={{ position: "absolute", right: "10" }} />
                  )}
                </div>
              );
            })}
            <hr />

            <div
              style={{
                margin: "10px auto",
                display: "flex",
                justifyContent: "space-between"
              }}
            >
              <Button variant="outlined" onClick={closeLeadStatusChangeModal}>
                Close
              </Button>
            </div>
          </div>
        </Box>
      </Modal>
      <Modal
        open={convertmemberModal}
        onClose={cancelModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...style }}>
          <Typography
            align="center"
            id="modal-modal-title"
            variant="h4"
            component="h2"
            style={{ borderBottom: "2px solid #000" }}
          >
            Lead Convert To Member
          </Typography>
          <div style={{ padding: "10px" }}>
            <div
              style={{
                maxHeight: "420px",
                overflow: "scroll",
                padding: "10px"
              }}
            >
              <Stack spacing={10} style={{ marginBottom: "10px", marginTop: "10px" }}>
                <Stack spacing={10} style={{ marginBottom: "15px" }}>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <Grid item xs={4}>
                        <FormLabel
                          id="demo-row-radio-buttons-group-label"
                          style={{ marginBottom: "0px" }}
                        >
                          Payment Mode
                        </FormLabel>
                        <RadioGroup
                          style={{ marginTop: "0px", display: "flex", flexFlow: "row" }}
                          row
                          value={memberdata.pr_payment_mode}
                          onChange={handlememberform}
                          aria-labelledby="demo-row-radio-buttons-group-label"
                          name="pr_payment_mode"
                        >
                          <FormControlLabel value="1" control={<Radio />} label="Offline" />
                          <FormControlLabel value="0" control={<Radio />} label="Online" />
                        </RadioGroup>
                      </Grid>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <TextField
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="text"
                          label="Without GST Amount"
                          name="pr_without_gst_amt"
                          value={memberdata?.pr_without_gst_amt}
                          onChange={handlememberform}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <TextField
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="text"
                          label="Amount"
                          name="pr_amount"
                          value={memberdata?.pr_amount}
                          onChange={handlememberform}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <TextField
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="text"
                          label="Transaction Id"
                          name="pr_transaction_id"
                          value={memberdata?.pr_transaction_id}
                          onChange={handlememberform}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={10} style={{ marginBottom: "15px" }}>
                        <FormControl component="fieldset">
                          <FormLabel component="legend">Gender</FormLabel>

                          <RadioGroup
                            name="gender"
                            row // remove this if you want vertical
                            value={memberdata?.gender || ""}
                            onChange={handlememberform}
                          >
                            {gender
                              .filter((g) => g.value !== 0) // remove "Select Gender"
                              .map((g) => (
                                <FormControlLabel
                                  key={g.value}
                                  value={g.value}
                                  control={<Radio />}
                                  label={g.label}
                                />
                              ))}
                          </RadioGroup>
                        </FormControl>
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <TextField
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="text"
                          label="Member Name"
                          name="name"
                          value={memberdata?.name}
                          onChange={handlememberform}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <TextField
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="email"
                          label="Member Email Id"
                          name="l_email"
                          value={memberdata?.l_email}
                          onChange={handlememberform}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <TextField
                          inputProps={{
                            inputMode: "numeric",
                            pattern: "[0-9]*"
                          }}
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="number"
                          label="Member Contact No"
                          name="l_contact_no"
                          value={memberdata?.l_contact_no}
                          onChange={handlememberform}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <TextField
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="text"
                          label="Member Password"
                          name="password"
                          value={memberdata?.password}
                          onChange={handlememberform}
                        />
                      </Stack>
                    </Grid>
                  </Grid>
                </Stack>
              </Stack>
            </div>
            <hr />
            <div
              style={{
                margin: "10px auto",
                display: "flex",
                justifyContent: "space-between"
              }}
            >
              <Button
                variant="outlined"
                onClick={() => {
                  setIsLoading_leadConvertMember(false);
                  setConvertMemberModal(false);
                  setnewmemberdata({
                    pr_payment_mode: 1,
                    pr_amount: 0,
                    pr_without_gst_amt: 0,
                    pr_transaction_id: "",
                    m_name: "",
                    mobile_no: "",
                    m_email_id: "",
                    password: ""
                  });
                }}
              >
                Close
              </Button>
              <Button
                variant="contained"
                disabled={isLoading_leadConvertMember}
                onClick={submitMemberForm}
                startIcon={
                  isLoading_leadConvertMember && <CircularProgress size={20} color="inherit" />
                }
              >
                Confirm
                {isLoading_leadConvertMember && (
                  <CircularProgress size={14} style={{ marginLeft: "5px" }} />
                )}
              </Button>
            </div>
          </div>
        </Box>
      </Modal>

      <Page title="Lead | Local Vocal Business Group">
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
            <Typography variant="h4" gutterBottom>
              Lead
            </Typography>
          </Stack>
          {step == 1 ? (
            <>
              <Button
                onClick={() => {
                  setStep(0);
                  setformdata({ l_created_by: loginUser.u_id, l_type: 0 });
                }}
                style={{ marginBottom: "15px" }}
                variant="contained"
              >
                Back
              </Button>
              <Card
                style={{
                  padding: "25px",
                  paddingBottom: "25px",
                  marginBottom: "25px"
                }}
              >
                Add New Lead
                <Stack spacing={10} style={{ marginBottom: "15px" }}>
                  <Grid container spacing={2}>
                    {step != 2 && (
                      <>
                        <Grid item xs={6}>
                          <Stack spacing={10} style={{ marginBottom: "15px" }}>
                            <label style={{ marginBottom: "10px" }}>Allocate To</label>
                            <Select
                              value={
                                allocatelist &&
                                allocatelist
                                  ?.map((p) => {
                                    if (p.u_id == formdata.l_allocated_to) {
                                      return { value: p.u_id, label: p.u_name };
                                    }
                                  })
                                  .filter((n) => n)[0]
                              }
                              style={{ marginTop: "0px" }}
                              name="l_allocated_to"
                              onChange={(e) => {
                                setformdata({
                                  ...formdata,
                                  l_allocated_to: e.value
                                });
                              }}
                              options={
                                allocatelist != null &&
                                allocatelist?.map((p) => {
                                  return { value: p.u_id, label: p.u_name };
                                })
                              }
                            ></Select>
                          </Stack>
                        </Grid>
                        <Grid item xs={6}>
                          <Stack spacing={10} style={{ marginBottom: "15px" }}>
                            <label style={{ marginBottom: "10px" }}>Status</label>
                            <Select
                              value={
                                statusList &&
                                statusList
                                  ?.map((p) => {
                                    if (p.value == formdata.l_phase) {
                                      return { value: p.value, label: p.label };
                                    }
                                  })
                                  .filter((n) => n)[0]
                              }
                              style={{ marginTop: "0px" }}
                              name="l_phase"
                              onChange={(e) => {
                                setformdata({ ...formdata, l_phase: e.value });
                              }}
                              options={statusList?.filter((p) => [0, 1].includes(p.value))}
                            ></Select>
                          </Stack>
                        </Grid>
                      </>
                    )}
                    <Grid item xs={6}>
                      <Stack spacing={10} style={{ marginBottom: "15px" }}>
                        <FormControl component="fieldset">
                          <FormLabel component="legend">Gender</FormLabel>

                          <RadioGroup
                            name="gender"
                            row // remove this if you want vertical
                            value={formdata?.gender || ""}
                            onChange={onChangeFunction}
                          >
                            {gender
                              .filter((g) => g.value !== 0) // remove "Select Gender"
                              .map((g) => (
                                <FormControlLabel
                                  key={g.value}
                                  value={g.value}
                                  control={<Radio />}
                                  label={g.label}
                                />
                              ))}
                          </RadioGroup>
                        </FormControl>
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <TextField
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="text"
                          label="Name"
                          name="name"
                          value={formdata?.name}
                          onChange={onChangeFunction}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <TextField
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="email"
                          label="Email"
                          name="l_email"
                          value={formdata?.l_email}
                          onChange={onChangeFunction}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <TextField
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          inputProps={{ maxLength: 10 }}
                          type="text"
                          label="Contact No"
                          name="l_contact_no"
                          value={formdata?.l_contact_no}
                          onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, "");

                            onChangeFunction({
                              target: {
                                name: e.target.name,
                                value: value
                              }
                            });
                          }}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <TextField
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="text"
                          label="Address"
                          name="l_address"
                          value={formdata?.l_address}
                          onChange={onChangeFunction}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <TextField
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="text"
                          label="Business Name"
                          name="l_business_name"
                          value={formdata?.l_business_name}
                          onChange={onChangeFunction}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <TextField
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="text"
                          label="Business Category"
                          name="l_business_category"
                          value={formdata?.l_business_category}
                          onChange={onChangeFunction}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <label>Reference By</label>
                        <Select
                          isClearable
                          isLoading={memberSearchLoading}
                          options={memberOptions.map((m) => ({
                            label: m.m_name,
                            value: m.m_id
                          }))}
                          value={selectedMember}
                          onChange={(selected) => {
                            setSelectedMember(selected);
                            setformdata({ ...formdata, l_ref_m_id: selected?.value || "" });
                          }}
                          onInputChange={handleMemberSearch}
                          onMenuScrollToBottom={loadMoreMembers}
                          onMenuOpen={() => {
                            if (memberOptions.length === 0) fetchMemberOptions("");
                          }}
                          placeholder="Search member..."
                          menuPortalTarget={document.body}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={3}>
                        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enGB}>
                          <DatePicker
                            disableFuture
                            type="date"
                            label="Date"
                            inputFormat="dd/MM/yyyy"
                            value={
                              formdata.date
                                ? new Date(formdata.date.split("-").reverse().join("-")) // Converts "DD-MM-YYYY" to "YYYY-MM-DD"
                                : null
                            }
                            onChange={(newDate) => {
                              if (newDate instanceof Date && !isNaN(newDate)) {
                                const day = String(newDate.getDate()).padStart(2, "0");
                                const month = String(newDate.getMonth() + 1).padStart(2, "0");
                                const year = newDate.getFullYear();
                                setformdata({
                                  ...formdata,
                                  date: `${day}-${month}-${year}`
                                });
                              }
                            }}
                            renderInput={(params) => <TextField {...params} fullWidth />}
                          />
                        </LocalizationProvider>
                        {/* <LocalizationProvider
                          dateAdapter={AdapterDateFns}
                          style={{ marginTop: "15px" }}
                        >
                          <DatePicker
                            type="date"
                            name="date"
                            label="Date"
                            inputFormat="dd/MM/yyyy"
                            value={moment(formdata.date, "DD-MM-YYYY")}
                            onChange={(newDate) => {
                              setformdata({
                                ...formdata,
                                date: moment(newDate, "DD-MM-YYYY").format("DD-MM-YYYY")
                              });
                            }}
                            renderInput={(params) => <TextField {...params} />}
                          />
                        </LocalizationProvider> */}
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={10} style={{ marginBottom: "15px" }}>
                        <TextField
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="text"
                          label="District"
                          name="l_district"
                          value={formdata?.l_district}
                          onChange={onChangeFunction}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={10} style={{ marginBottom: "15px" }}>
                        <TextField
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="text"
                          label="Taluka"
                          name="l_taluka"
                          value={formdata?.l_taluka}
                          onChange={onChangeFunction}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={10} style={{ marginBottom: "15px" }}>
                        <TextField
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="text"
                          label="Village"
                          name="l_village"
                          value={formdata?.l_village}
                          onChange={onChangeFunction}
                        />
                      </Stack>
                    </Grid>
                  </Grid>
                </Stack>
                <Button
                  style={{ marginTop: "15px" }}
                  variant="contained"
                  onClick={submitformdata}
                  disabled={isLoading}
                  startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
                >
                  Save
                </Button>
              </Card>
            </>
          ) : step == 2 ? (
            <>
              <Button
                onClick={() => {
                  setStep(0);
                  setformdata({ l_created_by: loginUser.u_id, l_type: 0 });
                }}
                style={{ marginBottom: "15px" }}
                variant="contained"
              >
                Back
              </Button>
              <Card className="p-20">
                Edit Lead
                <Stack spacing={10} style={{ marginBottom: "15px" }}>
                  <Grid container spacing={2}>
                    {step != 2 && (
                      <>
                        <Grid item xs={6}>
                          <Stack spacing={10} style={{ marginBottom: "15px" }}>
                            <label style={{ marginBottom: "10px" }}>Allocate To</label>
                            <Select
                              value={
                                allocatelist &&
                                allocatelist
                                  ?.map((p) => {
                                    if (p.u_id == formdata.l_allocated_to) {
                                      return { value: p.u_id, label: p.u_name };
                                    }
                                  })
                                  .filter((n) => n)[0]
                              }
                              style={{ marginTop: "0px" }}
                              name="l_allocated_to"
                              onChange={(e) => {
                                setformdata({
                                  ...formdata,
                                  l_allocated_to: e.value
                                });
                              }}
                              options={
                                allocatelist != null &&
                                allocatelist?.map((p) => {
                                  return { value: p.u_id, label: p.u_name };
                                })
                              }
                            ></Select>
                          </Stack>
                        </Grid>
                        <Grid item xs={6}>
                          <Stack spacing={10} style={{ marginBottom: "15px" }}>
                            <label style={{ marginBottom: "10px" }}>Status</label>
                            <Select
                              value={
                                statusList &&
                                statusList
                                  ?.map((p) => {
                                    if (p.value == formdata.l_phase) {
                                      return { value: p.value, label: p.label };
                                    }
                                  })
                                  .filter((n) => n)[0]
                              }
                              style={{ marginTop: "0px" }}
                              name="l_phase"
                              onChange={(e) => {
                                setformdata({ ...formdata, l_phase: e.value });
                              }}
                              options={statusList}
                            ></Select>
                          </Stack>
                        </Grid>
                      </>
                    )}
                    <Grid item xs={6}>
                      <Stack spacing={10} style={{ marginBottom: "15px" }}>
                        <FormControl component="fieldset">
                          <FormLabel component="legend">Gender</FormLabel>

                          <RadioGroup
                            name="gender"
                            row // remove this if you want vertical
                            value={formdata?.gender || ""}
                            onChange={onChangeFunction}
                          >
                            {gender
                              .filter((g) => g.value !== 0) // remove "Select Gender"
                              .map((g) => (
                                <FormControlLabel
                                  key={g.value}
                                  value={g.value}
                                  control={<Radio />}
                                  label={g.label}
                                />
                              ))}
                          </RadioGroup>
                        </FormControl>
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <TextField
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="text"
                          label="Name"
                          name="name"
                          value={formdata?.name}
                          onChange={onChangeFunction}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <TextField
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="email"
                          label="Email"
                          name="l_email"
                          value={formdata?.l_email}
                          onChange={onChangeFunction}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <TextField
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="text"
                          label="Contact No"
                          name="l_contact_no"
                          inputProps={{ maxLength: 10 }}
                          value={formdata?.l_contact_no}
                          onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, "");

                            onChangeFunction({
                              target: {
                                name: e.target.name,
                                value: value
                              }
                            });
                          }}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <TextField
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="text"
                          label="Address"
                          name="l_address"
                          value={formdata?.l_address}
                          onChange={onChangeFunction}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <TextField
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="text"
                          label="Business Name"
                          name="l_business_name"
                          value={formdata?.l_business_name}
                          onChange={onChangeFunction}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <TextField
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="text"
                          label="Business Category"
                          name="l_business_category"
                          value={formdata?.l_business_category}
                          onChange={onChangeFunction}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <label>{formdata?.m_referral_code ? "Referral By" : "Reference By"}</label>
                        <Select
                          isClearable
                          isDisabled={!!formdata?.m_referral_code}
                          isLoading={memberSearchLoading}
                          options={memberOptions.map((m) => ({
                            label: m.m_name,
                            value: m.m_id
                          }))}
                          value={selectedMember}
                          onChange={(selected) => {
                            setSelectedMember(selected);
                            setformdata({ ...formdata, l_ref_m_id: selected?.value || "" });
                          }}
                          onInputChange={handleMemberSearch}
                          onMenuScrollToBottom={loadMoreMembers}
                          onMenuOpen={() => {
                            if (memberOptions.length === 0) fetchMemberOptions("");
                          }}
                          placeholder="Search member..."
                          menuPortalTarget={document.body}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <TextField
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="text"
                          label="District"
                          name="l_district"
                          value={formdata?.l_district}
                          onChange={onChangeFunction}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <TextField
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="text"
                          label="Taluka"
                          name="l_taluka"
                          value={formdata?.l_taluka}
                          onChange={onChangeFunction}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={6}>
                      <Stack spacing={3} style={{ marginBottom: "15px" }}>
                        <TextField
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="text"
                          label="Village"
                          name="l_village"
                          value={formdata?.l_village}
                          onChange={onChangeFunction}
                        />
                      </Stack>
                    </Grid>
                    {/* <Grid item xs={6}>
                      <Stack spacing={3}>
                        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enGB}>
                          <DatePicker
                            type="date"
                            label="Date"
                            inputFormat="dd/MM/yyyy"
                            value={
                              formdata.date
                                ? new Date(formdata.date.split("-").reverse().join("-")) // Converts "DD-MM-YYYY" to "YYYY-MM-DD"
                                : null
                            }
                            onChange={(newDate) => {
                              if (newDate instanceof Date && !isNaN(newDate)) {
                                const day = String(newDate.getDate()).padStart(2, "0");
                                const month = String(newDate.getMonth() + 1).padStart(2, "0");
                                const year = newDate.getFullYear();
                                setformdata({
                                  ...formdata,
                                  date: `${day}-${month}-${year}`
                                });
                              }
                            }}
                            renderInput={(params) => <TextField {...params} fullWidth />}
                          />
                        </LocalizationProvider>
                      </Stack>
                    </Grid> */}
                  </Grid>
                </Stack>
                <Button
                  style={{ marginTop: "15px" }}
                  variant="contained"
                  onClick={submitformdata}
                  disabled={isLoading}
                  startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
                >
                  Save
                </Button>
              </Card>
            </>
          ) : (
            <>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Button
                  onClick={() => {
                    setStep(1);
                  }}
                  style={{ marginBottom: "15px" }}
                  variant="contained"
                >
                  Add Lead
                </Button>
                <Button
                  className="btn btn-export"
                  style={{ marginBottom: "15px", marginTop: "0" }}
                  variant="contained"
                  onClick={exportFilteredLead}
                  disabled={loading}
                  startIcon={loading && <CircularProgress size={20} color="inherit" />}
                >
                  {loading ? "Exporting..." : "Export CSV"}
                </Button>
              </div>
              <Card className="p-20">
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Stack spacing={3} style={{ marginBottom: "15px" }}>
                      <TextField
                        fullWidth
                        value={filterlead?.filterl}
                        autoComplete="off"
                        type="text"
                        label="Search Lead"
                        name="search"
                        onChange={(e) => {
                          setfilterlead({
                            ...filterlead,
                            filterl: e.target.value
                          });
                        }}
                      />
                    </Stack>
                  </Grid>

                  <Grid item xs={3}>
                    <Stack spacing={3} style={{ marginBottom: "15px" }}>
                      {/* <label style={{ marginBottom: '10px' }}>Join Date</label> */}
                      <LocalizationProvider
                        dateAdapter={AdapterDateFns}
                        adapterLocale={enGB}
                        style={{ marginTop: "15px" }}
                      >
                        <DatePicker
                          type="date"
                          name="s_date"
                          label="Start Date "
                          inputFormat="dd/MM/yyyy"
                          value={
                            filterlead.s_date
                              ? new Date(filterlead.s_date.split("-").reverse().join("-")) // Converts "DD-MM-YYYY" to "YYYY-MM-DD"
                              : null
                          }
                          onChange={(newDate) => {
                            if (newDate instanceof Date && !isNaN(newDate)) {
                              const day = String(newDate.getDate()).padStart(2, "0");
                              const month = String(newDate.getMonth() + 1).padStart(2, "0");
                              const year = newDate.getFullYear();
                              setfilterlead({
                                ...filterlead,
                                s_date: `${day}-${month}-${year}`
                              });
                            }
                          }}
                          renderInput={(params) => (
                            <TextField {...params} onKeyDown={(e) => e.preventDefault()} />
                          )}
                        />
                      </LocalizationProvider>
                    </Stack>
                  </Grid>
                  <Grid item xs={3}>
                    <Stack spacing={3} style={{ marginBottom: "15px" }}>
                      {/* <label style={{ marginBottom: '10px' }}>Join Date</label> */}
                      <LocalizationProvider
                        dateAdapter={AdapterDateFns}
                        adapterLocale={enGB}
                        style={{ marginTop: "15px" }}
                      >
                        <DatePicker
                          type="date"
                          name="e_date"
                          label="End Date "
                          inputFormat="dd/MM/yyyy"
                          value={
                            filterlead.e_date
                              ? new Date(filterlead.e_date.split("-").reverse().join("-")) // Converts "DD-MM-YYYY" to "YYYY-MM-DD"
                              : null
                          }
                          onChange={(newDate) => {
                            if (newDate instanceof Date && !isNaN(newDate)) {
                              const day = String(newDate.getDate()).padStart(2, "0");
                              const month = String(newDate.getMonth() + 1).padStart(2, "0");
                              const year = newDate.getFullYear();
                              setfilterlead({
                                ...filterlead,
                                e_date: `${day}-${month}-${year}`
                              });
                            }
                          }}
                          renderInput={(params) => (
                            <TextField {...params} onKeyDown={(e) => e.preventDefault()} />
                          )}
                        />
                      </LocalizationProvider>
                    </Stack>
                  </Grid>
                  <Grid item xs={3}>
                    <Stack spacing={3} style={{ marginBottom: "15px" }}>
                      <label>Select User</label>
                      <Select
                        value={filterOption?.map((st) => {
                          if (st.value == filterlead.filteruser) {
                            return { value: st.value, label: st.label };
                          }
                        })}
                        menuPortalTarget={document.body}
                        onChange={(e) => {
                          setfilterlead({
                            ...filterlead,
                            filteruser: e.value
                          });
                        }}
                        options={filterOption}
                      />
                    </Stack>
                  </Grid>
                  <Grid item xs={3}>
                    <Stack spacing={3} style={{ marginBottom: "15px" }}>
                      <label>Select Lead Status</label>
                      <Select
                        //filter.lead_status
                        value={
                          filterlead.lead_status == -1
                            ? { value: -1, label: "All Lead" }
                            : statusList?.map((st) => {
                              if (st.value == filterlead.lead_status) {
                                return { value: st.value, label: st.label };
                              }
                            })
                        }
                        menuPortalTarget={document.body}
                        onChange={(e) => {
                          setfilterlead({
                            ...filterlead,
                            lead_status: e.value
                          });
                        }}
                        options={[{ value: -1, label: "All Lead" }, ...statusList]}
                      />
                    </Stack>
                  </Grid>

                  <Grid item xs={3}>
                    <Stack spacing={3} style={{ marginBottom: "15px" }}>
                      <label>Select Lead Type</label>
                      <Select
                        value={SearchTypeOptions?.map((st) => {
                          if (st.value == filterlead.lead_type) {
                            return { value: st.value, label: st.label };
                          }
                        })}
                        menuPortalTarget={document.body}
                        onChange={(e) => {
                          setfilterlead({ ...filterlead, lead_type: e.value });
                        }}
                        options={SearchTypeOptions}
                      />
                    </Stack>
                  </Grid>
                  <Grid item xs={2}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-around"
                      }}
                    >
                      <Button
                        style={{ marginTop: "15px" }}
                        onClick={() => {
                          setLoadingMoreData(-1);
                          getFilterLeadData();
                        }}
                        variant="contained"
                      >
                        search
                      </Button>
                      <Button
                        style={{ marginTop: "15px" }}
                        onClick={async () => {
                          await setLoadingMoreData(-1);
                          await setfilterlead({
                            u_id: loginUser.u_id,
                            u_type: loginUser.u_type,
                            filterl: "",
                            s_date: null,
                            e_date: null,
                            filteruser: 0,
                            l_phase: -1,
                            lead_status: -1,
                            lead_type: -1
                          });
                          await resetSearchForm({
                            u_id: loginUser.u_id,
                            u_type: loginUser.u_type,
                            filterl: "",
                            s_date: null,
                            e_date: null,
                            filteruser: 0,
                            l_phase: -1,
                            lead_status: -1,
                            lead_type: -1
                          });
                        }}
                        variant="contained"
                      >
                        clear
                      </Button>
                    </div>
                  </Grid>
                </Grid>
              </Card>
              {step == 0 &&
                (isLoading ? (
                  <CustomLoader />
                ) : (
                  <Board
                    className="taskList"
                    data={leadList}
                    style={{ position: "relative", marginTop: "15px" }}
                    components={{ Card: CustomCard }}
                    onCardClick={async (cardId, metadata, phase) => {
                      setValue("1");
                      setMyModal({
                        mval: true,
                        p_lead_id: cardId,
                        l_phase: phase
                      });
                      setLeadHistory(await fetchPrimeleadhistory(cardId));
                      setExpanded(0);
                    }}
                    handleDragEnd={async (
                      id,
                      sourceLaneId,
                      targetLaneId,
                      position,
                      cardDetails
                    ) => {
                      await leadStatusChange(id, targetLaneId, sourceLaneId);
                    }}
                    onLaneScroll={(requestedPage, laneId) => handleCustomLaneScroll(laneId, false)}
                  />
                ))}
              {step == 3 && newleadData && (
                <>
                  <Button className="btn btn-export">
                    <CSVLink
                      data={newleadData}
                      headers={expo_columns}
                      filename={"LeadData.csv"}
                      className="btn btn-primary test"
                      target="_blank"
                    >
                      Export CSV
                    </CSVLink>
                  </Button>
                  <DataTable
                    title="Lead List"
                    filter
                    pagination
                    highlightOnHover
                    columns={columns}
                    data={newleadData}
                  />
                </>
              )}
            </>
          )}
        </Container>
      </Page>
    </>
  );
}
